import * as PharmacyToolsActions from '../actions/update.tools.actions';

const initialState = {
  backfillLoading: false,
  settingLoading: false,
  backfillJobRunning: false,
  backfillJobStatusLoaded: false,
};

const tools = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case PharmacyToolsActions.START_VPB_HISTORY_SUMMARY_BACKFILL:
      return { ...state, backfillLoading: true };
    case PharmacyToolsActions.END_VPB_HISTORY_SUMMARY_BACKFILL:
      return { ...state, backfillLoading: false };
    case PharmacyToolsActions.START_VPB_HISTORY_SUMMARY_SETTING:
      return { ...state, settingLoading: true };
    case PharmacyToolsActions.END_VPB_HISTORY_SUMMARY_SETTING:
      return { ...state, settingLoading: false };
    case PharmacyToolsActions.SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING: {
      const next = { ...state };
      if (typeof action.payload.isRunning === 'boolean') {
        next.backfillJobRunning = action.payload.isRunning;
      }
      if (typeof action.payload.statusLoaded === 'boolean') {
        next.backfillJobStatusLoaded = action.payload.statusLoaded;
      }
      return next;
    }
    default:
      return state;
  }
};

export default tools;
